import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

import PhoneBase from '../../Interface/PhoneBase/PhoneBase';
import TabsUI from '../../Interface/TabsUI';
import { generateAutocompleteItems } from '../../../utils/helper';
import masterDataService from '../../../service/masterData.service';
import { useLoader } from '../../../provider/LoaderProvider';
import InprogressPurchaseDelivery from './InprogressPurchaseDelivery';
import NewPurchaseDelivery from './NewPurchaseDelivery';
import PurchaseDeliveryDocsTab from './PurchaseDeliveryDocsTab';

const PurchaseDeliveryPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { showLoader, hideLoader } = useLoader();
  const [autocompleteData, setAutocompleteData] = useState({
    warehouse: [],
    company: [],
    user: [],
  });
  const [autocompleteOptions, setAutocompleteOptions] = useState({
    warehouse: [],
    company: [],
    user: [],
  });

  useEffect(() => {
    const loadAutocompleteData = async () => {
      showLoader();
      try {
        const [warehouse, company, user] = await Promise.all([
          masterDataService.warehouseToForm(),
          masterDataService.companyToForm(),
          masterDataService.usersToForm(),
        ]);

        setAutocompleteData({
          warehouse: Array.isArray(warehouse) ? warehouse : [],
          company: Array.isArray(company) ? company : [],
          user: Array.isArray(user) ? user : [],
        });

        const supplierCompanies = (company ?? []).filter((item) => item.active && item.supplier);
        setAutocompleteOptions({
          warehouse: generateAutocompleteItems(warehouse ?? [], ['code', 'name'], 'code'),
          company: generateAutocompleteItems(supplierCompanies, ['code', 'name'], 'id'),
          user: generateAutocompleteItems(user ?? [], 'nickName', 'userId'),
        });
      } finally {
        hideLoader();
      }
    };

    loadAutocompleteData();
  }, []);

  const tabs = [
    {
      id: 0,
      name: 'Bizonylatok',
      content: (
        <PurchaseDeliveryDocsTab autocompleteData={autocompleteData} autocompleteOptions={autocompleteOptions} />
      ),
    },
    {
      id: 1,
      name: 'Új indítása',
      content: <NewPurchaseDelivery autocompleteData={autocompleteData} autocompleteOptions={autocompleteOptions} />,
    },
    {
      id: 2,
      name: 'Folyamatban',
      content: (
        <InprogressPurchaseDelivery autocompleteData={autocompleteData} autocompleteOptions={autocompleteOptions} />
      ),
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <PhoneBase name="PurchaseDelivery">
      <Typography variant="h5" sx={{ fontWeight: 400, py: 1, px: 2 }}>
        Árubeérkezés
      </Typography>
      <TabsUI activeTab={activeTab} handleTabClick={handleTabClick} disablePadding>
        {tabs.map((tab, index) => (
          <div key={index} name={tab.name}>
            {tab.content}
          </div>
        ))}
      </TabsUI>
    </PhoneBase>
  );
};

export default PurchaseDeliveryPage;
